import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Flow from 'garaje/models/flow';
import type Location from 'garaje/models/location';
import type StateService from 'garaje/services/state';

import type { VisitorsQuestionnairesRouteModel } from '../route';

export type VisitorsQuestionnairesIndexRouteModel = {
  flows: Flow[];
  location: Location;
};

export default class VisitorsQuestionnairesIndexRoute extends Route {
  @service declare state: StateService;

  model(): VisitorsQuestionnairesIndexRouteModel {
    const { flows } = <VisitorsQuestionnairesRouteModel>this.modelFor('visitors.questionnaires');
    return {
      flows,
      location: this.state.currentLocation,
    };
  }
}
